import PropTypes from 'prop-types';
import { OVERWRITE_ORGANIGRAM_CONFIGS } from '../actionTypes';

export const initialState = [];

/**
 * invite config reducer
 * see https://redux.js.org/
 * @param {object} state
 * @param {object} action
 */

const reducers = (state = initialState, action) => {
    if (action.type === OVERWRITE_ORGANIGRAM_CONFIGS) {
        return [...action.configs];
    }
    return state;
};

export const inviteProptype = {
    id: PropTypes.number,
    organigrams: PropTypes.arrayOf(PropTypes.array),
};

export default reducers;
